import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { IRuntimeEnvironment, RequestConfigProperties } from 'interfaces-lib';
import { jwtDecode } from 'jwt-decode';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';
import { AbstractAuthService } from './auth.service';
import { currentUser } from './current-user';

@Injectable({ providedIn: 'root' })
export class BullhornAuthService extends AbstractAuthService {
  private static readonly BULLHORN_URL_REGEX = new RegExp(/https:\/\/[^.]+\.bullhornstaffing/);

  constructor(
    identityStorage: IdentityStorage,
    http: HttpClient,
    serviceProvider: SharedServiceProviderServiceFactory
    ) {
    super(identityStorage, http, serviceProvider);
    console.log('BullhornAuthService created.');
  }

  getRequestProperties(req: HttpRequest<any>, token: string): RequestConfigProperties | undefined {
    const decoded = jwtDecode<any>(token);

    if (req.url.match(BullhornAuthService.BULLHORN_URL_REGEX)) {
      return { setParams: { BhRestToken: decoded.BhRestToken } };
    }

    return undefined;
  }

  override getTenantId(jwt: string) {
    const decoded = jwtDecode<any>(jwt);
    return decoded["corporationId"].toString();
  }

  protected getNamespace(): Namespace {
    return Namespace.bullhorn;
  }

  protected getRequestAuthenticationHostUrl(): string {
    const callbackUrl = `${this.environment.uiHost}/callback?instance=${this.instanceId}`;
    return `${this.environment.kpHost}/auth/bullhorn/host?targetCallback=${encodeURIComponent(callbackUrl)}&region=${this.getRegion()}`;
  }

  protected override postTokenAction(jwt: string): void {
    const identity = this.identityStorage.get();
    if (identity) {
      identity.tenant = jwtDecode<any>(jwt).corporationName;
      this.identityStorage.put(identity);
    }
    this.setCurrentUser(jwt);
    if (this.runtimeEnvironment) {
      this.setClientName(jwt);
    }
  }

  private setCurrentUser(jwt: string): void {
    const decoded = jwtDecode<any>(jwt);
    currentUser.userInfo = {
      id: decoded.userId,
      name: decoded.name,
      email: decoded.email,
    };
  }

  private setClientName(jwt: string): void {
    const jwtPayload = jwtDecode<any>(jwt);
    const runtimeEnvironment = this.runtimeEnvironment as IRuntimeEnvironment;
    runtimeEnvironment.client.name = jwtPayload.corporationName;
    console.debug(`Setting client name from token to ${runtimeEnvironment.client.name}.`);
  }

  private getRegion(): string {
    return new URLSearchParams(window.location.search).get('region') || '';
  }
}
